import React, { useState, useRef, useEffect } from "react";

const countries = [
  { code: "FR", symbol: "€", name: "France" },
  { code: "GB", symbol: "£", name: "United Kingdom" },
  { code: "IN", symbol: "₹", name: "India" },
  { code: "JP", symbol: "¥", name: "Japan" },
  { code: "US", symbol: "$", name: "United States" },
];

const CountrySelector = () => {
  const [selected, setSelected] = useState(countries[4]); // Default: $ United States
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative inline-block text-left">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 bg-[#171725] hover:bg-[#1f2033] border border-gray-700 text-white rounded-md px-3 py-1.5 text-sm font-medium transition-all shadow-md focus:outline-none"
      >
        <span>
          {selected.symbol} {selected.name}
        </span>
        <svg
          className={`w-4 h-4 text-gray-300 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-52 rounded-md bg-[#171725] border border-gray-700 shadow-2xl p-1.5 z-50">
          <div className="space-y-1">
            {countries.map((country) => {
              const isSelected = selected.code === country.code;
              return (
                <button
                  key={country.code}
                  onClick={() => {
                    setSelected(country);
                    setIsOpen(false);
                  }}
                  className={`flex items-center w-full px-3 py-1.5 text-sm font-medium rounded-md transition-all text-left ${
                    isSelected
                      ? "text-white bg-white/10 border border-gray-600"
                      : "text-gray-200 hover:bg-white/8 hover:text-white border border-transparent"
                  }`}
                >
                  <span className="w-5 text-center mr-2 text-gray-300 font-normal">
                    {isSelected ? "✓" : ""}
                  </span>
                  <span>
                    {country.symbol} {country.name}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelector;
